import { Link } from "react-router-dom";

const entries = [
  { label: "剧情", desc: "人物与生活的重量", icon: "ri-book-open-line", path: "/category?genre=剧情" },
  { label: "爱情", desc: "错过与重逢", icon: "ri-heart-3-line", path: "/category?genre=爱情" },
  { label: "悬疑", desc: "真相藏在沉默里", icon: "ri-search-eye-line", path: "/category?genre=悬疑" },
  { label: "动作", desc: "刃与追捕", icon: "ri-sword-line", path: "/category?genre=动作" },
  { label: "经典", desc: "被时间洗过的光", icon: "ri-film-line", path: "/category?genre=经典" },
  { label: "青春", desc: "夏天与告白", icon: "ri-sun-line", path: "/category?genre=青春" },
];

export default function GenreEntry() {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-8 md:py-10">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-5">
          <h2 className="font-heading text-lg md:text-xl text-foreground-950">按类型浏览</h2>
          <Link
            to="/category"
            className="inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            全部分类
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          {entries.map((entry) => (
            <Link
              key={entry.label}
              to={entry.path}
              className="group flex items-center gap-3 p-3.5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50/60 transition-colors cursor-pointer"
            >
              <span className="w-9 h-9 shrink-0 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center group-hover:bg-primary-600 group-hover:text-background-50 transition-colors">
                <i className={`${entry.icon} text-base w-4 h-4 flex items-center justify-center`}></i>
              </span>
              <span className="min-w-0">
                <span className="block text-sm text-foreground-900">{entry.label}</span>
                <span className="block text-[11px] text-foreground-500 truncate">{entry.desc}</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}